/* eslint-disable*/
import Vue from 'vue'; // 引入vue
import VueI18n from 'vue-i18n'; // 引入i18n模块
import Cookies from 'js-cookie'; // 封装了获取，设置，删除cookie的方法
import en from './en.json'; // 本地英文包
import zhCN from './zh-cn.json'; // 本地简体中文包
import zhTW from './zh-tw.json'; // 本地繁体中文包
import ja from './ja.json'; // 本地日文包
import ko from './ko.json'; // 本地韩文包
import th from './th.json'; // 本地泰文包
import pt from './pt.json'; // 本地葡文包
import id from './id.json'; // 本地印尼包
import it from './it.json'; // 本地意大利语包
import fr from './fr.json'; // 本地法语包
import de from './de.json'; // 本地德语包

Vue.use(VueI18n);

// 引入本地
const messages = {
    'zh-cn': zhCN,
    'zh-tw': zhTW,
    en,
    ja,
    ko,
    th,
    pt,
    id,
    it,
    fr,
    de,
};

// 创建国际化实例
function createVueI18n(options = {}) {
    return new VueI18n(
        Object.assign(
            {
                locale: Cookies.get('language') || 'en', // 值要与 messages 中的 key 一致
                messages,
                fallbackLocale: 'en',
                silentTranslationWarn: true,
            },
            options
        )
    );
}

export default createVueI18n;
